import api from "./api";

const RESOURCE = "/api/convenio";

const Convenio = {
  findById: async (id) => await api.get(RESOURCE + `/${id}`),
  listData: async (id) => await api.get(RESOURCE + `/pessoa/${id}`),
  sendData: async (data) => await api.post(RESOURCE, { ...data }),
  editingData: async (id, data) =>
    await api.put(RESOURCE + `/${id}`, { ...data }),
  searchConvenios: async (data) =>
    await api.get(RESOURCE + `/buscar?cnpjOuNome=${data || ""}`),
};

export default Convenio;
